<template>
  <div class="live-training-individual-page">
    <Training :info="info">
      <VideoPlayer
        v-if="info.video && videoJSLoaded" slot="player" :video-id="info.video"
        class="video-player"
      />
      <GetAccess
        slot="get-access" :features="features" button-text="Sign Up"
        button-link="/live-trainings/signup/"
      />
      <div v-if="info.trainingSlider && info.trainingSlider.length" slot="slider" class="section trainings-slider">
        <div class="container">
          <div class="col-10 offset-1">
            <Slider :disabled="info.trainingSlider.length <= 3" dark>
              <h3 slot="heading">
                Other Live Training
              </h3>
              <Card
                v-for="(training, id) in info.trainingSlider"
                slot="slide" :key="id"
                :training="training"
                :to="`/live-trainings/${training.slug}/`"
                heading="h4"
                dark
              />
            </Slider>
          </div>
        </div>
      </div>
    </Training>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Training from '@itbpbg/lms-components/src/Business/LiveTrainings/Training';
import Card from '@itbpbg/lms-components/src/Business/LiveTrainings/Card';
import VideoPlayer from '@itbpbg/lms-components/src/components/VideoPlayer.vue';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import GetAccess from '../../components/Business/GetAccess';

export default {
  components: {
    Training,
    Card,
    VideoPlayer,
    Slider,
    GetAccess,
  },
  mixins: [global],
  // middleware({ redirect }) {
  //   redirect('/');
  // },
  async asyncData({
    $axios, route, $config, error,
  }) {
    const info = await $axios.$get(`/business/live-trainings/${route.params.slug}/?slider=true`).catch(() => false);

    if (!info.title || $config.platform === 'fa') {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    info.fullPath = `${$config.siteUrl}${route.fullPath}`;
    return {
      info,
      metaTitles: {
        'data-quality-how-to-prevent-diagnose-and-cure-bad-data': 'Data Quality: How to Prevent and Cure Bad Data',
        'data-science-and-machine-learning-in-healthcare-solving-real-life-business-problems': 'Data Science & Machine Learning in Healthcare',
        'data-smart-marketing-make-data-driven-marketing-decisions': 'Data-Smart Marketing for Data-Driven Decisions',
        'data-visualizations-dashboards-that-will-10x-your-business-1': 'Data Visualizations & Dashboards to 10x Your Business',
        'from-excel-to-tableau-transform-your-spreadsheets-into-powerful-visualizations': 'From Excel to Tableau: Transforming Data Visualization',
        'machine-learning-at-light-speed-rapidly-deploy-applications-to-the-cloud': 'Machine Learning: Rapidly Deploy Apps to the Cloud',
        'mathematics-for-data-scientists-machine-learning-engineers': 'Math for Data Scientists & ML Engineers',
        'mindspeaking-from-data-to-business-the-complete-training-program': 'MindSpeaking: From Data to Business – Full Training',
        'revolutionizing-sales-outcomes-a-data-driven-experience-for-sales-leaders': 'Revolutionizing Sales Outcomes with Data for Sales Leaders',
        'the-depths-of-deep-learning-how-to-automate-your-processes': 'Deep Learning: How to Automate Processes',
        'the-design-to-act-scale-data-literacy-and-storytelling-within-your-organization': 'Design To Act®: Scaling Data Literacy & Storytelling',
        'thoughtful-analytics-how-to-drive-business-and-product-success': 'Thoughtful Analytics: Drive Business & Product Success',
      },
      metaDescriptions: {
        'thoughtful-analytics-how-to-drive-business-and-product-success': 'Transform your data and fuel company growth with a robust framework designed to produce business and product success. Sign up to learn live with Shailvi Wakhlu.',
        'architecting-the-ethics-of-ai-and-data-science': 'Develop a practical understanding of AI ethics and how to create responsible, long-lasting AI solutions. Sign up to learn live with Vidhi Chugh.',
        'data-science-and-machine-learning-in-healthcare-solving-real-life-business-problems': 'Help employees understand how to apply data science and machine learning to real-life healthcare business problems. Sign up to learn live with Vamsi Nellutla.',
        'computer-vision-with-neural-nets': 'Master the full machine learning workflow and learn to apply neural networks to key computer vision problems. Sign up to learn live with Richmond Alake.',
        'how-to-master-user-stories': 'Master user story essentials to facilitate trouble-free product development and provide high-quality value to customers. Sign up to learn live with Marios Prifti.',
        'the-design-to-act-scale-data-literacy-and-storytelling-within-your-organization': 'Upskill your data teams with crucial storytelling abilities to drive business insight and spark innovation. Sign up to learn live with Lee Feinberg.',
        'how-to-use-data-to-grow-your-business': 'Scale your organization with the power of data. Learn to apply FAANG data strategies for data-driven business growth. Sign up to learn live with Tina Huang.',
        'how-to-create-data-content': 'Create data content and build an actionable product-focused content strategy for greater traction. Sign up to learn live with Ken Jee and Tina Huang.',
        'communication-skills-for-data-professionals': 'Equip your data team with communication skills for presenting inisghts and analytics to maximize their impact. Sign up to learn live with Gilbert Eijkelenboom.',
        'setting-up-your-data-teams-for-success': 'Create a stimulating environment for your data talent and learn to effectively integrate data teams into your company. Sign up to learn live with Davis Balaba.',
        'data-science-in-insurance': 'Drive product innovation, risk analysis, and personalized services with data science techniques for insurance. Sign up to learn live with Sujata Suvarnapathaki.',
        'how-to-use-facebook-s-growth-framework-to-expand-your-company-effectively': 'Capitalize on your data integration by following Facebook’s product-building growth framework and boost your ROI. Sign up to learn live with Davis Balaba.',
        'designing-ethical-ai-systems': 'Design ethical AI systems with top tech companies\' frameworks. Navigate your company to value-oriented digital transformation. Sign up to learn live with Ken Jee.',
        'from-excel-to-tableau-transform-your-spreadsheets-into-powerful-visualizations': 'Empower your teams to switch from Excel to Tableau and reach new standards in data organization and visualization. Sign up to learn live with Shashank Kalanithi.',
        'data-science-for-non-technical-people': 'Improve decision-making with a data-oriented strategy and build a better understanding of data across your organization. Sign up to learn live with Ken Jee.',
        'machine-learning-at-light-speed-rapidly-deploy-applications-to-the-cloud': 'Upskill teams in cloud-based machine learning optimization tools to boost predictive analytics with agile models. Sign up to learn live with Shashank Kalanithi.',
        'mindspeaking-from-data-to-business-the-complete-training-program': 'Empower your data team with top-level communication and persuasion skills to turn business goals into reality. Sign up to learn live with Gilbert Eijkelenboom.',
        'building-reports-in-power-bi': 'Improve your team\'s visual data storytelling skills with Power BI for more interactive and informative business reports. Sign up to learn live with Dimitar Shutev.',
        'data-quality-how-to-prevent-diagnose-and-cure-bad-data': 'Secure your business\' long-term success with high-quality data and learn how to prevent, diagnose, and cure bad data. Sign up to learn live with Shailvi Wakhlu.',
        'shape-your-data-with-power-query': 'Prime your data team with Power Query and optimize the workflow in favor of your business reporting needs. Sign up to learn live with Dimitar Shutev.',
        'the-complete-dax-training': 'Empower your team to solve complex calculations quickly with Microsoft’s native formula and query language DAX. Sign up to learn live with Dimitar Shutev.',
        'data-literacy': 'Build a data-driven culture and develop data literacy for confident comprehension and gleaming valuable insights. Sign up to learn live with Jordan Morrow.',
        'build-a-data-driven-organization': 'Master the data-driven approach. Lead your organization with evidence-based decision-making to reach operational goals. Sign up to learn live with Jordan Morrow.',
        'the-depths-of-deep-learning-how-to-automate-your-processes': 'Future-proof your business with advanced deep learning algorithms and automate processes for bigger and better results. Sign up to learn live with Amin Uddin.',
        'extract-value-from-your-data': 'Improve your team\'s ability to tackle challenges with company data and extract value and become an agile industry leader. Sign up to learn live with Avery Smith.',
        'revolutionizing-sales-outcomes-a-data-driven-experience-for-sales-leaders': 'Scale your business and revenue growth with data-driven sales strategies and the 4-step diffusion of innovation framework. Sign up to learn live with Manuj Aggarwal.',
        'data-visualizations-dashboards-that-will-10x-your-business-1': 'Upskill your team with data visualization tools & dashboards that will transform your company into a data-first enterprise. Sign up to learn live with Avery Smith.',
        'data-smart-marketing-make-data-driven-marketing-decisions': 'Master the art of human-centered data-driven marketing and decision-making to drive profitable campaigns. Sign up to learn live with Manuj Aggarwal.',
        'machine-learning-algorithms-101': 'Equip your data team with the skills to apply essential machine learning algorithms to complex real-world problems. Sign up to learn live with Amin Uddin.',
        'data-science-in-retail-and-fmcg': 'Boost growth with cutting-edge data science practices and gain a competitive edge in Retail and FMCG. Sign up to learn live with Vinayak Deshpande.',
        'solving-problems-the-machine-learning-way': 'Promote computational thinking and build sustainable strategy solutions with business-defining machine learning models. Sign up to learn live with Ajay Halthor.',
        'data-science-in-banking-and-financial-services': 'Boost growth with cutting-edge data science practices and gain a competitive edge in Banking and Financal Services. Sign up to learn live with Vinayak Deshpande.',
        'sql-for-solving-problems': 'Master SQL—a fundamental data science tool. Leverage its functionalities for alleviating crucial business pain points. Sign up to learn live with Ajay Halthor.',
        'data-science-in-hr': 'Hire top talent for your company’s success. Employ data-driven HR strategies to recruit and retain the best team. Sign up to learn live with Vinayak Deshpande.',
        'mathematics-for-data-scientists-machine-learning-engineers': 'Equip your teams with the mathematics knowledge to master top problem-solving tools and thrive in a data-first future. Sign up to learn live with Ajay Halthor.',
      },
    };
  },
  data() {
    return {
      videoJSLoaded: false,
      features: [
        { name: 'Renowned Industry Experts' },
        { name: 'Community-Fostered Active Learning' },
        { name: 'Training for All Skill Levels and Expertise' },
        { name: 'Certificates of Achievement' },
      ],
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      {
        key: 'WebPage',
        values: {
          ...this.info,
          metaTitle: this.info.title,
        },
      },
      {
        key: 'Person',
        values: {
          name: this.info.author,
          url: `${this.$config.siteUrl}${this.$route.fullPath}`,
          image: {
            '@type': 'ImageObject',
            url: `${this.$config.imagesUrl}/team/${this.info.image}`,
            caption: `${this.info.author}'s image`,
          },
        },
      },
    ]);

    const metaTitle = this.metaTitles[this.$route.params.slug] || this.info.title;

    return {
      titleTemplate: `${metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps({
        ...this.info,
        metaTitle,
        metaDescription: this.metaDescriptions[this.$route.params.slug] || '',
      }),
      script: [
        linkedData,
        { src: 'https://players.brightcove.net/6258000438001/FHDad0Z7G_default/index.min.js', async: true },
      ],
    };
  },
  async mounted() {
    await this.$pollValue(() => typeof videojs !== 'undefined');
    this.videoJSLoaded = true;
  },
  methods: {
  },
};
</script>

<style lang="scss">
.live-training-individual-page {
  .training-page {
    .trainings-slider {
      background-color: var(--main-dark);
      color: var(--main-light);

      .slider-container {
        .row {
          margin-left: -23px;
          margin-right: -23px;

          .col {
            padding-left: 23px;
            padding-right: 23px;
          }
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .live-training-individual-page {
    .training-page {
      .trainings-slider {
        .slider-container {
          .slider-header {
            flex-direction: column;

            .controls {
              display: flex;
            }
          }

          .training-card {
            .image-holder {
              height: 195px;
            }
          }

          .dots {
            display: none;
          }
        }
      }
    }
  }
}
</style>
